import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0541cb9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "rows", "value", "autofocus"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("textarea", {
    name: _ctx.name,
    rows: _ctx.rows,
    class: _normalizeClass(_ctx.className),
    value: _ctx.modelValue,
    autofocus: _ctx.autofocus,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
  }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1))
}